import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgShieldDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};

export const SvgShield = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    width={SvgShieldDimension.width}
    height={SvgShieldDimension.height}
    viewBox={SvgShieldDimension.viewBox}
    fill="none"
    {...props}
  >
    <path
      d="M9.83282 13.4438C10.4831 13.7398 11.0936 13.8879 11.6641 13.8879C11.9954 13.8879 12.2408 13.828 12.4003 13.7083C12.5598 13.5823 12.6396 13.3871 12.6396 13.1225C12.6396 12.9335 12.5567 12.7697 12.3911 12.6312C12.2316 12.4926 11.934 12.3446 11.4985 12.1871C10.8727 11.9603 10.4248 11.6894 10.1549 11.3745C9.88497 11.0532 9.75 10.6501 9.75 10.165C9.75 9.7493 9.84509 9.38079 10.0353 9.05953C10.2316 8.73827 10.5107 8.48945 10.8727 8.31308C11.2347 8.1304 11.661 8.03906 12.1518 8.03906C12.7224 8.03906 13.2163 8.143 13.6334 8.35087L13.8359 9.81544C13.2837 9.50678 12.75 9.35245 12.2347 9.35245C11.9647 9.35245 11.7469 9.42174 11.5813 9.56032C11.4156 9.6926 11.3328 9.87843 11.3328 10.1178C11.3328 10.332 11.4156 10.5146 11.5813 10.6658C11.7531 10.8107 12.0567 10.9587 12.4923 11.1099C13.1242 11.3304 13.5752 11.5981 13.8451 11.9131C14.115 12.2217 14.25 12.6217 14.25 13.1131C14.25 13.5477 14.1457 13.9257 13.9371 14.2469C13.7347 14.5682 13.4555 14.8138 13.0997 14.9839C12.7439 15.154 12.3451 15.239 11.9034 15.239C11.1979 15.239 10.5567 15.1257 9.98006 14.8989L9.83282 13.4438Z"
      fill="currentColor"
    />
    <path
      d="M12.0002 19.1998C10.3322 18.7798 8.95523 17.8228 7.86923 16.3288C6.78323 14.8348 6.24023 13.1758 6.24023 11.3518V6.9598L12.0002 4.7998L17.7602 6.9598V11.3518C17.7602 13.1758 17.2172 14.8348 16.1312 16.3288C15.0452 17.8228 13.6682 18.7798 12.0002 19.1998ZM12.0002 17.6878C13.2482 17.2918 14.2802 16.4998 15.0962 15.3118C15.9122 14.1238 16.3202 12.8038 16.3202 11.3518V7.9498L12.0002 6.3298L7.68023 7.9498V11.3518C7.68023 12.8038 8.08823 14.1238 8.90423 15.3118C9.72023 16.4998 10.7522 17.2918 12.0002 17.6878Z"
      fill="currentColor"
    />
  </svg>
));
